import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { User } from '../types';

interface UserAvatarProps extends AvatarProps {
    user?: User | { name: string; profile_picture?: string };
    name?: string;
    src?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, name, src, ...props }) => {
    const userName = user?.name || name || '';
    // If user object is provided, prefer its profile_picture, otherwise fall back to src
    const userSrc = (user && 'profile_picture' in user) ? user.profile_picture : src;

    // Function to generate initials
    const getInitials = (name: string) => {
        if (!name) return '';
        return name
            .split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    // Function to generate consistent background color based on name
    const stringToColor = (string: string) => {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    };

    // Only calculate color if we are going to show initials
    const bgcolor = !userSrc && userName ? stringToColor(userName) : (props.sx as any)?.bgcolor;

    return (
        <Avatar
            src={userSrc}
            alt={userName}
            {...props}
            sx={{
                bgcolor: bgcolor,
                ...props.sx,
            }}
        >
            {!userSrc && userName ? getInitials(userName) : props.children}
        </Avatar>
    );
};

export default UserAvatar;
